import Cookies from 'js-cookie';

export const AUTH_TOKEN = 'ma-authtoken';
export const AUTH_TOKEN_LEGACY = 'authtoken';
export const SELECTED_MENU = 'ma-samclick_menu';
export const CURRENT_USER = 'ma-auth.currentUser';
export const CURRENT_USER_LANG = 'ma-samclick_lang';
export const IS_ADMIN = 'ma-isAdmin';
export const BANNER_IS_CLOSED = 'ma-samclick-banner-closed';
export const SHOW_BG = 'show-bg';

export function getItem(key: string) {
    return window.localStorage.getItem(key);
}

export function setItem(key: string, item: any) {
    window.localStorage.setItem(key, JSON.stringify(item));
}

export function removeItem(key: string) {
    window.localStorage.removeItem(key);
}

export function getCookieValue(a: string) {
    const b = window.document.cookie.match(`(^|;)\\s*${a}\\s*=\\s*([^;]+)`);
    return b ? b.pop() : '';
}

export function getSessionItem(key: string) {
    return window.sessionStorage.getItem(key);
}

export function setSessionItem(key: string, item: any) {
    window.sessionStorage.setItem(key, JSON.stringify(item));
}

export function removeSessionItem(key: string) {
    window.sessionStorage.removeItem(key);
}

export function getCookiesItem(key: string) {
    return Cookies.get(key);
}

export function setCookiesItem(key: string, item: any) {
    Cookies.set(key, JSON.stringify(item));
}

export function removeCookiesItem(key: string) {
    Cookies.remove(key);
}

export function getAuthorizationToken() {
    const primary = getCookiesItem(AUTH_TOKEN);
    const legacy = getCookiesItem(AUTH_TOKEN_LEGACY);
    const token = primary || legacy || '';
    return token ? token.replace('%20', ' ') : '';
}

export function parseJWT(token: string) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const utf8Str = decodeURIComponent(escape(window.atob(base64)));
    return JSON.parse(utf8Str);
}

/* export function validateScopes(scope: string) {
  const jwtToken = parseJWT(getCookieValue(AUTH_TOKEN) || '');

  if (jwtToken.scopes.indexOf(scope) === -1) {
    return false;
  }
  return true;
} */
